import { useQuery } from '@tanstack/react-query'
import clsx from 'clsx'
import { iotDevicesApi } from '../../services/iotDevicesApi'

export function isMqttDeviceKind(kind) {
  return kind === 2 || kind === 'Mqtt' || kind === '2'
}

/**
 * Coluna Plataforma: para MQTT mostra estado no EMQX (username = DevEUI); senão usa renderNonMqtt().
 */
export function MqttEmqxPlataformaCell({ device, renderNonMqtt }) {
  const deviceId = device?.id
  const kind = device?.kind

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['device-emqx', deviceId],
    queryFn: () => iotDevicesApi.getEmqxClientStatus(deviceId),
    enabled: isMqttDeviceKind(kind) && !!deviceId,
    staleTime: 30_000,
    refetchInterval: () =>
      typeof document !== 'undefined' && document.hidden ? false : 60_000,
    refetchIntervalInBackground: false,
  })

  if (!isMqttDeviceKind(kind)) {
    return renderNonMqtt()
  }

  if (isLoading && !data) {
    return <span className="text-xs text-gray-400">MQTT…</span>
  }

  if (data && !data.brokerConfigured) {
    return (
      <span
        className="badge badge-gray cursor-help"
        title={data.errorMessage || 'Configure EMQX na API (EMQX:ApiUrl ou BrokerUrl + usuário/senha da API REST)'}
      >
        MQTT (sem API)
      </span>
    )
  }

  const errMsg =
    data?.errorMessage ||
    (isError && (error?.response?.data?.message || error?.message)) ||
    null

  if (!data?.querySucceeded) {
    return (
      <span
        className="badge badge-warning cursor-help"
        title={errMsg || 'Consulta ao broker falhou'}
      >
        MQTT indisponivel
      </span>
    )
  }

  const connected = data.anyConnected
  const sessions = data.sessions || []

  return (
    <div className="space-y-1">
      <span
        className={clsx('badge', connected ? 'badge-success' : 'badge-gray')}
        title={`Username broker: ${data.username || '—'}`}
      >
        {connected ? 'MQTT online' : 'MQTT offline'}
      </span>
      {sessions.length > 0 && (
        <ul className="text-[10px] text-gray-600 space-y-0.5 list-disc pl-3.5 leading-snug">
          {sessions.slice(0, 3).map((s, i) => (
            <li
              key={s.clientId ? `${s.clientId}-${i}` : `sess-${i}`}
              title={`Cliente ${s.clientId} · ${s.protoName || 'MQTT'} ${s.protoVer ?? ''}`}
            >
              ↓{Number(s.recvCnt ?? 0)} / ↑{Number(s.sendCnt ?? 0)} · {s.ipAddress || '—'}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
